/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         20/03/24 - 8:44
 * Module name:  customer-models.interface
 * File name:    customers.interface.ts
 * IDE:          WebStorm
 */

import {MkadResumeDataListInterface, MkadSummaryListInterface} from '@shared/interface';
import {FormControl, ValidatorFn} from '@angular/forms';
import {customerFields} from '@shared/utils';

export interface MkadPhoneInterface {
  dial_code: string;
  phone_number: number;
}

const CustomerFinalLevel = 10;

export enum CustomerLevelEnum {
  diamond,
  zafiro,
  platinum,
  gold,
  silver,
  final = CustomerFinalLevel,
}

export interface CustomerResumeInterface extends MkadResumeDataListInterface<number> {
}

export interface CustomerSummaryInterface extends MkadSummaryListInterface {
}

export interface CustomerPhoneInterface {
  dial_code: string;
  phone_number: number;
}

export interface CustomerFormInterface {
  id?: number;
  tax_id: string;
  name: string;
  address: string;
  phone: CustomerPhoneInterface;
  initials: string;
  enabled: boolean;
  allow_public_devs: boolean;
  logo: string | null;
  level: CustomerLevelEnum;
  allow_customers: boolean;
  parent: number;
  has_children: boolean;
  has_children_customers: boolean;
  has_public_devs: boolean;
}

export type CustomerValidatorsMapType = Record<customerFields | 'indicator'| 'level', () => ValidatorFn[]>;

/**
 * @description
 * Interface for customer list typing
 */
export interface CustomersListInterface extends Omit<
  CustomerFormInterface, 'address' | 'phone' | 'allow_public_devs' | 'parent' | 'has_children' | 'has_children_customers' | 'has_public_devs'
> {
  id: number;
  has_superadmin: boolean;
  has_dependency: boolean;
}

export interface CustomersListPayload {
  image_size: number;
  customer?: number;
}

export interface CustomerFormControls {
  nit: FormControl<string>;
  name: FormControl<string>;
  address: FormControl<string>;
  phone: FormControl<string>;
  initials: FormControl<string>;
  indicators: FormControl<string | null>;
  enable: FormControl<boolean>;
  logo: FormControl<string | null>;
  devices: FormControl<boolean>;
  level: FormControl<number | null>;
  finalClient: FormControl<boolean>;
}

export enum CustomerListViewEnum {
  partners,
  clients,
}

export interface CustomerParentsListPayload {
  customer: number;
}

export interface CustomerParentUpdatePayload {
  id: number;
  parent: number;
}

export interface CustomerParentsListInterface {
  allow_customers: boolean;
  enabled: boolean;
  children: CustomerParentsListInterface[];
  description: string;
  id: number;
  level: CustomerLevelEnum;
  parent: number | null;
}

export interface CustomerLevelDataInterface {
  value: number;
  label: string;
}
export interface CustomerLevelsListInterface {
  customer: {
    level: CustomerLevelDataInterface[]
  };
}

export interface CustomerSummaryParamsInterface {
  level: CustomerLevelEnum;
  all: boolean;
}
